<template>
  <Wizzard
    title="Add Real Estate"
    name="Real Estate"
    :modal
    :preset
    :steps="STEPS_LIST"
    :transaction-type="TRANSACTION_TYPE"
    :account-type="ACCOUNT_TYPE"
    :asset-type="ASSET_TYPE"
    :asset-classes-list="ASSET_CLASSES_LIST"
    :investment-strategies-list="INVESTMENT_STRATEGIES_LIST"
    disallow-existing-account
  >
    <template #step1="{ account, asset }">
      <RealEstateProperty v-if="account && asset" :account :asset />
    </template>
    <template #step2="{ transaction, asset }">
      <RealEstatePurchase :asset :transaction />
    </template>
  </Wizzard>
</template>

<script setup lang="ts">
import { provide } from 'vue'
import { ModalClass } from '@types'
import { InputWizardPreset } from '../utils/types'

import {
  ACCOUNT_TYPE,
  ASSET_CLASSES_LIST,
  ASSET_TYPE,
  INVESTMENT_STRATEGIES_LIST,
  STEPS_LIST,
  TRANSACTION_TYPE,
} from './utils/const'

import Wizzard from '../components/Wizzard.vue'
import RealEstateProperty from './RealEstateProperty.vue'
import RealEstatePurchase from './RealEstatePurchase.vue'

type Props = {
  modal: ModalClass<any>
  preset?: InputWizardPreset
}

defineProps<Props>()

provide('valuePlaceholder', 'Value')
provide('summaryData', [
  ['date', 'Date of purchase'],
  ['asset-name', 'Property name'],
  ['description', 'Description'],
  ['amount', 'Cost'],
])
</script>
